var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"Icon",class:_vm.iconClass,style:([_vm.iconStyles, { color: _vm.cmpColor }]),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }